var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.nextEpisode.id)?_c('span',{directives:[{name:"accessibility-focus",rawName:"v-accessibility-focus",value:(_vm.playNextEpisode),expression:"playNextEpisode"}],staticClass:"o-typography__label o-button__label"},[_vm._v(" "+_vm._s(_vm.event.title)+" "+_vm._s(_vm.timeToNextEpisode)+"s ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }